/**
 * Déconnexion demandée par l'utilisateur : la page quittée n'a pas à être rouverte après la prochaine connexion
 * (RequireStaff n'ajoute `?redirect=` qu'à une session perdue). Vaut jusqu'au rechargement complet que la
 * déconnexion déclenche.
 */
let voluntaryLogout = false;

export function markVoluntaryLogout(): void {
    voluntaryLogout = true;
}

export function isVoluntaryLogout(): boolean {
    return voluntaryLogout;
}
